var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudyDm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.543 34.2134C7.79381 34.2134 3.94385 30.3634 3.94385 25.6142C3.94385 20.8651 7.79381 17.0151 12.543 17.0151C13.5728 17.0151 14.5602 17.1961 15.4754 17.528C17.2809 13.1117 21.6202 10 26.6863 10C33.3726 10 38.793 15.4203 38.793 22.1067C38.793 22.4012 38.7825 22.6933 38.7618 22.9826C40.7838 23.9136 42.1874 25.9578 42.1874 28.3297C42.1874 31.5792 39.5532 34.2134 36.3038 34.2134H12.543Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudyDm);
export default __webpack_public_path__ + "static/media/cloudy-dm.a1a96b0dbf7beec8e6dfa98cf4dfeacd.svg";
export { ForwardRef as ReactComponent };